import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';

import { FormWithErrorsRegister } from '@/hooks/useFormWithErrors';
import { useTranslator } from '@/hooks/useTranslator';
import type { paymentMethodFiatSchema } from '@/schemas/paymentMethod';

type PaymentMethodForm = typeof paymentMethodFiatSchema.infer;

interface Props {
  readonly register: FormWithErrorsRegister<PaymentMethodForm>;
}

export const PIXAccountDetailsFields: React.FC<Props> = ({
  register,
}: Props): React.ReactElement => {
  const tr = useTranslator();

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="body2" color="text.primary">
        {tr('BANK_ACCOUNT_INFORMATION')}
      </Typography>
      <TextField {...register({ name: 'pixKey', label: tr('PIX_KEY') })} />
      <TextField {...register({ name: 'documentNumber', label: tr('DOCUMENT_NUMBER_CPF_CNPJ') })} />
    </Box>
  );
};
